<template>
  <createContent/>
</template>

<script>
import createContent from '@/components/_authorityservices/requestServiceList.vue'
export default {
  components: {
    createContent
  }
}
</script>
